import React from "react";

import useProducts from "../../../hooks/useProducts";
import Product from "../../Product/Product";
import "./Products.css";
const Products = () => {
  const [products] = useProducts();

  const forSliceProducts = [...products];

  return (
    <div className="container">
      <h1 className="text-center my-3 mt-5 fw-bold">Products</h1>
      <div className="products-container">
        {forSliceProducts.splice(0, 6).map((product) => (
          <Product key={product._id} product={product}></Product>
        ))}
      </div>
    </div>
  );
};

export default Products;
